/**
 * Persistent per-browser device identifier used for attendance audit
 * (buddy-punching detection). Survives page reloads via localStorage.
 *
 * NOT a cryptographic identifier — purely a hint to correlate clock-in/out
 * events that come from the same browser on the same machine.
 */
const STORAGE_KEY = 'lucent_device_id';

function generateId() {
  // RFC4122-ish v4 UUID without the crypto polyfill dependency
  return 'd-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateId();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage may be blocked (private mode etc.) — fall back to a per-session id
    return 'd-ephemeral-' + Math.random().toString(16).slice(2, 10);
  }
}
